import GoalsExplanationModal from '../../../goals/components/summary/GoalsExplanationModal';

export default function GoalsExplanation() {
    return <GoalsExplanationModal />;
}
